module.exports = __webpack_public_path__ + "img/s_ele_left.3f7009c6.png";